import React from 'react';
import Text from '@rexlabs/text';
import { map } from 'shared/utils/text';

export default ({ white, ...props }) => (
  <Text
    is='p'
    {...props}
    type={map({
      SMALL: true,
      GREY: true,
      WHITE: white,
      REGULAR: true
    })}
  />
);
